import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";



const Table = ({ rows, columns }) => {
  const [tableRows, setTableRows] = useState([]);
  const [pageSize, setPageSize] = useState(100);

  useEffect(() => {
    if (rows?.length > 0) {
      setTableRows(rows);
      setPageSize(rows.length);
    }
  }, [rows]);

  return (
    <div className="w-full overflow-hidden">
      <div style={{ width: '100%', overflowX: 'auto' }}>
        <div style={{ minWidth: '100%', height: '100%' }}>
          <DataGrid
            rows={tableRows}
            columns={columns}
            pagination={true}
            pageSize={pageSize}
            rowsPerPageOptions={[pageSize]}
            disableSelectionOnClick
            sortingMode="client"
            initialState={{
              sorting: {
                sortModel: [{ field: columns[0]?.field || 'id', sort: 'asc' }],
              },
              pagination: {
                pageSize: pageSize,
              },
            }}
            autoHeight
            sx={{
              '& .MuiDataGrid-root': {
                border: 'none',
                maxWidth: '100%',
              },
              '& .MuiDataGrid-cell': {
                borderBottom: '1px solid #f0f0f0',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              },
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: '#fafafa',
                borderBottom: '2px solid #f0f0f0',
                whiteSpace: 'nowrap',
              },
              '& .MuiDataGrid-virtualScroller': {
                minHeight: '400px',
              },
              '& .MuiDataGrid-columnHeader': {
                padding: '0 16px',
                height: '48px',
                '& .MuiDataGrid-columnHeaderTitle': {
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                },
              },
              // Add horizontal scrolling for the table
              '& .MuiDataGrid-main': {
                overflow: 'auto',
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Table;